export default "__VITE_ASSET__CmzDm5_V__"